<script setup lang="ts">
import { ref } from "vue";
import { Card } from "@/components/ui/card";
import Globe from "@/components/ui/Globe.vue";
import RegionSearchDialog from "@/components/landing/region-search.vue";
import { Search } from "lucide-vue-next";

const dialogOpen = ref(false);
</script>

<template>
  <Card
    class="flex flex-col md:flex-row items-center justify-between mx-4 relative z-10 rounded-2xl bg-gradient-to-r from-background to-neutral-900 text-white -mb-44 overflow-hidden shadow-2xl shadow-[#8436B5]/20 border"
  >
    <!-- Content Section -->
    <div class="p-10 flex flex-col gap-4 z-20 relative">
      <h2 class="text-3xl md:text-4xl font-bold leading-tight">
        Stay connected
        <span class="lg:hidden md:inline sm:hidden"><br /></span> anywhere you
        travel
      </h2>
      <p class="text-neutral-400 text-lg">
        Instant eSIM activation in 200+
        <span class="lg:hidden md:inline sm:hidden"><br /></span> countries and
        regions.
      </p>

      <!-- Search Input Button -->
      <button
        @click="dialogOpen = true"
        class="mt-2 w-full max-w-sm flex items-center gap-3 pl-6 pr-4 py-2 bg-white rounded-full text-left text-neutral-500 font-medium shadow-lg transition-all duration-200 cursor-pointer brand-button-shadow"
      >
        <span class="flex-1 text-base">Search for destination</span>
        <div
          class="w-12 h-12 flex items-center justify-center bg-blue-500 rounded-xl"
        >
          <Search :size="20" class="text-white" />
        </div>
      </button>
    </div>

    <!-- Globe Section -->
    <div
      class="absolute right-0 top-0 w-[600px] h-[600px] overflow-hidden hidden md:block"
    >
      <div class="absolute -right-32 w-full h-full overflow-hidden">
        <Globe />
      </div>
    </div>

    <!-- Region Search Dialog -->
    <RegionSearchDialog
      v-model:open="dialogOpen"
      :disable-keyboard-shortcut="true"
    />
  </Card>
</template>
